import { RadioButton } from "./RadioButton";

interface Props {
    name: string;
    children?: React.ReactElement<typeof RadioButton>[];
    setValue: (value: string) => void;
}

export const RadioButtonGroup = ({ name, children, setValue }: Props) => {
    return (
        <>
            {children.map((child, index) => {
                if (!React.isValidElement(child)) return null;
                type ChildProps = React.ComponentProps<typeof RadioButton>;
                return React.cloneElement(child, {
                    name: name,
                    setValue: setValue,
                    key: index
                } as ChildProps);
            })}
        </>
    );
}
